<template>
    <the-header></the-header>
    <router-view></router-view>
</template>

<script>

import TheHeader from './components/layout/TheHeader.vue';


export default {

    components: {
        TheHeader,
       
    },
    computed: {
      didAutoLogout() {
        return this.$store.getters.didAutoLogout;
      }
    },

    created() {
      this.$store.dispatch('tryLogin');

    },
    watch: {
      didAutoLogout(curValue, oldValue) {
        if(curValue && curValue !== oldValue) {
          this.$router.replace('/skipper');
        }
      }
    }

}

</script>

<style>

@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");


* {
  box-sizing: border-box;
}

html {
  font-family: "Roboto", sans-serif;
}

body {
  margin: 0;

  /* BACKGROUND IMAGE:  https://cli.vuejs.org/guide/html-and-static-assets.html#the-public-folder*/
 
 
}

button {
  outline: none;
}

</style>